var map = {
	"./admins.png": 455,
	"./bills.png": 456,
	"./business-settings.png": 457,
	"./customers.png": 215,
	"./orders.png": 216,
	"./parcel-destination.png": 217,
	"./parcels.png": 130,
	"./reports.png": 218,
	"./settings.png": 219,
	"./shippings.png": 458,
	"./users.png": 459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 454;